import React from "react";
import MyImage from '../modules/MyImage';
import { Button, 
    HStack, Hide,
    Text, Box,
    VStack,
    Stack
} from '@chakra-ui/react';
import { useTheme } from '@chakra-ui/react';
import { TypeAnimation } from 'react-type-animation';
import myPic from '../../assets/images/profile.jpg';
import "../../theme/Project.css"
import { Link } from 'react-scroll';


export default function Hero(){
    const theme = useTheme();

        
    return(
        <Stack w='100%' direction={['column', 'row']} display= "flex"
        justifyContent={'center'}
        alignItems={'center'} 
        p={{ base: "1em", md: "1em", lg: "1em" }} bg={theme.colors.text}
        >   
        <Box w={{ base: "100%", md: "100%", lg: "55%", xl: "55%" }} display= "flex"
        justifyContent={'center'}
        alignItems={'center'} >
            <VStack w='100%' display= "flex"
            justifyContent={'center'}
            pt={{ base: "0.5em", md: "1em", lg: "3em" }}
            alignItems={'center'}
           >   
                <HStack w={'100%'}
                px={{ base: "0.25em", md: "0.25em", lg: "1em" }}
                h={{ base: "6em", md: "6em", lg: "5em", xl: "5em" }} >
                    <TypeAnimation
                        sequence={[
                            "Hi, my name is Ahmad Ayaan,",
                            1000, // Waits 1s
                            "I'm a Software Engineer.", 
                            2000, // Waits 2s
                        ]}
                        wrapper="span"
                        cursor={true}
                        repeat={Infinity}
                        style={{ fontSize: '42px', 
                        color: '#FFFFFF',
                        display: 'inline-block', 
                        fontFamily: 'Helvetica Neue',
                        fontWeight: '600' 
                                }}
                        />
                                
                </HStack>
                    
                <Text fontSize={{ base: "20px", md: "24px", lg: "24px" }}
                        weight={600}
                        pt={{ base: "0.5em", md: "0.5em", lg: "2em" }}
                        px={{ base: "0.25em", md: "0.25em", lg: "1em" }}
                        overflow={'hidden'}
                        wordBreak={'keep-all'}
                        overflowWrap={'break-word'}
                        fontFamily={theme.font.secondary}
                        color={theme.colors.primary}>
                      I'm a recent graduate from Multimedia University with a degree in Software Engineering. 
                        My journey in software engineering began in high school when I was first introduced to programming, and I’ve been honing my skills ever since. 
                        I have gained valuable experience through various projects and a year of part-time work as a backend/AI software engineer.
                        <br></br> <br></br>
                        <Hide breakpoint='(max-width: 800px)'>
                            As a motivated and detail-oriented graduate with a passion for software engineering, 
                            I possess a solid foundation in programming and problem-solving, with hands-on experience in languages such as 
                            <span style={{ color: theme.colors.secondText }}> Java, Python, C++</span>, and 
                            <span style={{ color: theme.colors.secondText }}> JavaScript</span>, 
                            as well as familiarity with frameworks and modern technologies.
                        </Hide>
                </Text>
                <HStack gap={'1.2em'} pt='2em' display= "flex"
                    justifyContent={'center'}
                    alignItems={'center'}>
                        <Link to="project" spy={true} 
                        smooth={true} offset={-70} 
                        duration={500}>
                            <Button color="white"
                                    borderRadius={50}
                                    size={{ base: "sm", md: "sm", lg: "md" }}
                                    p={'1em'}
                                    colorScheme='teal'
                                    bg = {theme.colors.secondary}
                                    fontSize={{ base: "14px", md: "18px", lg: "18px" }}>
                                        See my Projects
                            </Button>
                        </Link>
                        <Link to="project" spy={true} 
                            smooth={true} offset={-70} 
                            duration={500}>
                            <Button color="white"
                                    borderRadius={50}
                                    size={{ base: "sm", md: "sm", lg: "md" }}
                                    p={'1em'}
                                    colorScheme='teal'
                                    bg = {theme.colors.secondary}
                                    fontSize={{ base: "14px", md: "18px", lg: "18px" }}>
                                Let's Talk with Me
                            </Button>
                        </Link>
                    
                </HStack>
                
            </VStack>
        </Box>
            
        <Box w={{ base: "100%", md: "100%", lg: "45%", xl: "45%" }} py={'1em'}
        display= "flex"
        justifyContent={'center'}
        alignItems={'center'} >
            <MyImage color={theme.colors.thirdly} imageUrl={myPic} maxWidth="100%" />
        </Box>
            
        </Stack>
    );
}